import { useMemo } from "react";
import { useModels } from "@/hooks/useModels";

export function useModelDisplayName(model: string | undefined, mediaType: "image" | "video") {
  const { models } = useModels(mediaType);

  return useMemo(() => {
    if (!model) return undefined;
    const found = models.find((m) => m.id === model);
    return found?.displayName ?? model;
  }, [model, models]);
}
